<template>
  <div class="overflow: auto">
    <div class="query-c">
      <Select
        v-model="productId"
        @on-change="changeInput"
        style="width: 200px; margin-left: 10px"
        placeholder="请选择产品"
      >
        <Option
          v-for="(item, index) in ProductData"
          :value="item.value"
          :key="index"
          >{{ item.label }}</Option
        >
      </Select>
      <Select
        v-model="states"
        @on-change="changeInput"
        style="width: 200px; margin-left: 10px"
        placeholder="选择结算状态"
      >
        <Option
          v-for="(item, index) in types"
          :value="item.value"
          :key="index + 'c'"
          >{{ item.label }}</Option
        >
      </Select>

      <Input
        v-model="name"
        @input="changeInput()"
        search
        placeholder="输入办卡人姓名"
        style="width: auto; margin-left: 10px"
      />

      <Input
        v-model="userPhone"
        @input="changeInput()"
        search
        placeholder="代理人手机号"
        style="width: auto; margin-left: 10px"
      />
      <Input
        v-model="phone"
        @input="changeInput()"
        search
        placeholder="输入办卡人手机号"
        style="width: auto; margin-left: 10px"
      />
      <Input
        v-model="pincodes"
        @input="changeInput()"
        search
        placeholder="输入办卡人身份证"
        style="width: auto; margin-left: 10px"
      />
      <Input
        v-model="userName"
        @input="changeInput()"
        search
        placeholder="输入推荐人姓名"
        style="width: auto; margin-left: 10px"
      />
      <DatePicker
        type="daterange"
        split-panels
        placeholder="按时间查询"
        style="width: 200px; margin-left: 10px"
        @on-change="queryTime"
      ></DatePicker>
    </div>
    <br />
    <Table :content="self" border stripe :columns="columns1" :data="data1">
      <template slot="applyStatus" slot-scope="{ row, index }">
        <div v-if="row.applyStatus == 0">订单初始化</div>
        <div v-if="row.applyStatus == 1">初审失败</div>
        <div v-if="row.applyStatus == 2">初审通过</div>
        <div v-if="row.applyStatus == 3">激活成功</div>
        <div v-if="row.applyStatus == 4">已首刷</div>
        <div v-if="row.applyStatus == 5">终审失败</div>
        <div v-if="row.applyStatus == 6">终审成功</div>
      </template></Table
    >
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "OrderForm",

  data() {
    return {
      modal1: false,
      total: 0,
      stateList: "",
      states: "",
      time: [],
      phone: "",
      name: "",
      productId: "",
      self: this,
      userPhone: "",
      state: "",
      keyword: "",
      userName: "",
      pageNow: 1,
      ProductData: [],
      pincodes: "",
      Product: "",
      types: [
        {
          value: 1,
          label: "待确认",
        },
        {
          value: "2,3",
          label: "已完成",
        },

        {
          value: "4",
          label: "已作废",
        },
        {
          value: "5",
          label: "待激活面签",
        },
      ],
      type: "",
      columns1: [
        {
          title: "推荐人",
          align: "center",
          key: "userName",
        },
        {
          title: "进件日期",
          align: "center",
          key: "creationTime",
        },
        {
          title: "产品名称",
          align: "center",
          key: "productName",
        },
        {
          title: "结算状态",
          align: "center",
          key: "tag",
        },
        {
          title: "订单状态",
          align: "center",
          key: "userApplyStatusTitle",
        },
        {
          title: "用户姓名",
          align: "center",
          key: "name",
        },
        {
          title: "用户手机号",
          key: "phone",
          align: "center",
        },
      ],
      data1: [],
    };
  },

  activated: function () {
    this.getData("");
    this.getProduct();
  },
  methods: {
    getData() {
      if (this.states == "2,3") {
        this.stateList = [2, 3];
      }
      if (this.states == "") {
        this.stateList = null;
      }
      if (this.states == "1") {
        this.stateList = [1];
      }
      if (this.states == "2") {
        this.stateList = [2];
      }
      if (this.states == "4") {
        this.stateList = [4];
      }
      if (this.states == "5") {
        this.stateList = [5];
      }
      api
        .GetAllInformation({
          pageNow: this.pageNow,
          userPhone: this.userPhone,
          pageSize: "10",
          name: this.name,
          phone: this.phone,
          productId: this.productId,
          pincodes: this.pincodes,
          userName: this.userName,
          start: this.time[0],
          end: this.time[1],
          state: this.states,
          stateList: this.stateList,
        })
        .then((res) => {
          this.total = res.body.data.pageResult.total;
          this.data1 = res.body.data.pageResult.list;
          this.data1.forEach((element) => {
            if (element.state == 1) {
              element.state = "待确认";
            } else if (element.state == 2 || element.state == 3) {
              element.state = "已完成";
            } else if (element.state == 4) {
              element.state = "已作废";
            }
          });
        });
    },
    changeInput() {
      this.getData();
    },
    getProduct() {
      api
        .ProductSelectAll({
          pageNow: 1,
          pageSize: "1000",
        })
        .then((res) => {
          res.body.data.list.forEach((element) => {
            this.ProductData.push({
              value: element.id,
              label: element.productName,
            });
          });
        });
    },
    queryTime(time) {
      this.time[0] = new Date(time[0]).valueOf();
      this.time[1] = new Date(time[1]).valueOf();
      this.getData(this.keyword);
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData(this.keyword);
    },
  },
};
</script>

<style scoped>
.top {
  height: 70px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>